import React, {useEffect, useRef, useState} from "react";
import {useHistory} from "react-router";
import Button from "@mui/material/Button";
import "./anniv2026.css";
import {Login2026} from "./Login2026";
import {errorMessage, post} from "./api2026";
import {CategoryIcon, PodiumModal2026} from "./PodiumModal2026";
import {MyParties2026} from "./MyParties2026";

export const Anniv2026Page = () => {

    const history = useHistory();
    const [player, setPlayer] = useState(undefined);
    const [categories, setCategories] = useState([]);
    const [games, setGames] = useState([]);
    const [ballot, setBallot] = useState({});
    const [openCategory, setOpenCategory] = useState(undefined);
    const [saveStatus, setSaveStatus] = useState("");
    // votes are sent one after the other so the last change always wins
    const saveQueue = useRef(Promise.resolve());

    useEffect(() => {
        if (player) {
            post("/games").then(data => {
                setCategories(data.categories);
                setGames(data.games);
                setBallot(data.ballot || {});
            }).catch(err => setSaveStatus(errorMessage(err)));
        }
    }, [player]);

    function updatePodium(categoryId, podium) {
        const newBallot = {...ballot, [categoryId]: podium};
        setBallot(newBallot);
        setSaveStatus("Enregistrement...");
        saveQueue.current = saveQueue.current
            .then(() => post("/vote", {ballot: newBallot}))
            .then(() => setSaveStatus("Vote enregistré ✓"))
            .catch(err => setSaveStatus(errorMessage(err)));
    }

    const gamesById = {};
    games.forEach(game => gamesById[game.id] = game);
    // number of categories in which the player placed each game
    const votes = {};
    Object.values(ballot).forEach(podium => (podium || []).forEach(gameId => {
        if (gameId) {
            votes[gameId] = (votes[gameId] || 0) + 1;
        }
    }));
    const sortedGames = [...games].sort((a, b) => (votes[b.id] || 0) - (votes[a.id] || 0) || a.name.localeCompare(b.name));

    return (
        <div className="anniv2026">
            <div className="anniv2026-topbar">
                <div className="anniv2026-topbar-title">
                    <img className="anniv2026-topbar-logo" src="https://nostragames.ai/logo.png" alt="Nostra Games"/>
                    <span className="anniv2026-topbar-contest">Concours 2026</span>
                </div>
                {
                    player ?
                        <div className="anniv2026-topbar-player">
                            <span className="anniv2026-topbar-pill">Connecté : <b>{player.username}</b></span>
                            {
                                player.admin ?
                                    <Button className="anniv2026-topbar-admin" variant="contained" size="small"
                                            onClick={() => history.push("/anniv/2026/admin")}>Admin</Button> :
                                    undefined
                            }
                        </div> :
                        undefined
                }
            </div>
            <div className="anniv2026-content">
                {
                    !player ?
                        <Login2026 setPlayer={setPlayer}/> :
                        <div>
                            <h3>Les jeux</h3>
                            <div className="anniv2026-carousel">
                                {
                                    sortedGames.map(game =>
                                        <a key={game.id} className="anniv2026-card anniv2026-carousel-item" href={game.href} target="_blank" rel="noreferrer">
                                            {game.mine ? <div className="anniv2026-ribbon">mon jeu</div> : undefined}
                                            <img src={game.logo} alt={game.name}/>
                                            <div className="anniv2026-game-author">{game.authorName}</div>
                                            <div className={"anniv2026-game-votes" + (votes[game.id] ? "" : " none")}>
                                                {(votes[game.id] || 0) + (votes[game.id] > 1 ? " votes" : " vote")}
                                            </div>
                                        </a>
                                    )
                                }
                                {games.length === 0 ? <div>Aucun jeu pour le moment.</div> : undefined}
                            </div>

                            <h3>Les catégories</h3>
                            <div className="anniv2026-save-status">{saveStatus}</div>
                            <div className="anniv2026-carousel">
                                {
                                    categories.map(category => {
                                        const podium = ballot[category.id] || [null, null, null];
                                        const complete = [0, 1, 2].every(rank => podium[rank] && gamesById[podium[rank]]);
                                        return (
                                            <div key={category.id} className={"anniv2026-card anniv2026-category-tile" + (complete ? " complete" : "")}
                                                 onClick={() => setOpenCategory(category)}>
                                                {!complete ? <div className="anniv2026-ribbon">à compléter</div> : undefined}
                                                <CategoryIcon category={category}/>
                                                <div className="anniv2026-category-label">{category.label}</div>
                                                <div className="anniv2026-mini-podium">
                                                    {
                                                        // displayed order: 2nd, 1st, 3rd
                                                        [1, 0, 2].map(rank => {
                                                            const game = podium[rank] ? gamesById[podium[rank]] : undefined;
                                                            return game ?
                                                                <img key={rank} className={"anniv2026-mini-slot rank" + rank} src={game.logo} alt={game.name}/> :
                                                                <div key={rank} className={"anniv2026-mini-slot anniv2026-mini-empty rank" + rank}/>;
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        );
                                    })
                                }
                            </div>

                            <MyParties2026/>
                        </div>
                }
            </div>
            {
                openCategory ?
                    <PodiumModal2026
                        category={openCategory}
                        games={games}
                        podium={ballot[openCategory.id] || [null, null, null]}
                        setPodium={(podium) => updatePodium(openCategory.id, podium)}
                        onClose={() => setOpenCategory(undefined)}
                    /> :
                    undefined
            }
        </div>
    );
}
